<script setup>
import {setNoScroll} from "@/script/checkMenu";
import LoadingCircle from "@/components/loadingCircle.vue";

// console.log("no-scroll")
setNoScroll();
// console.log(document.body.classList)

</script>

<template>
  <div id="loading-bg">
    <slot name="header"></slot>
    <loading-circle></loading-circle>
  </div>
</template>

<style scoped lang="scss">
body {
  margin: 0;
}

//html {
//  overflow-x: hidden;
//  overflow-y: scroll;
//}

#loading-bg {
  //position: absolute;
  //display: flex;
  //flex-direction: column;
  //align-items: center;
  //justify-content: center;
  //background: rgba(255, 255, 255, 0.5);
  //block-size: 100%;
  //gap: 1rem 0;
  //inline-size: 100%;
  //
  //z-index: 999;
  //top: 0;
  //left: 0;

  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba( 0, 0, 0, 0.8);
  //background-color: black;
  height: 100%;
  width: 100%;
  z-index: 10000;
  top: 0;
  left: 0;
}

</style>